<div *ngIf="isLoading" class="loading-overlay" style="padding-right: 150px">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>

<div class="container">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-md-9 mb-3">
      <div class="options-panel">
        <span class="pagination-counter">{{
          'attendance.configuration-page.page-description' | translate
        }}</span>
        <span class="list-options">
          <button
            id="setup_general_btn_collapse_all"
            data-testid="setup_general_btn_collapse_all"
            *ngIf="expandAll"
            mat-icon-button
            matTooltip="{{ 'setup.common.collapse' | translate }}"
            (click)="expandAll = false"
          >
            <mat-icon>unfold_less</mat-icon>
          </button>

          <button
            id="setup_general_btn_expand_all"
            data-testid="setup_general_btn_expand_all"
            *ngIf="!expandAll"
            mat-icon-button
            matTooltip="{{ 'setup.common.expand' | translate }}"
            (click)="expandAll = true"
          >
            <mat-icon>unfold_more</mat-icon>
          </button>
        </span>
      </div>

      <mat-accordion multi class="ml-3">
        <mat-expansion-panel
          [expanded]="expandAll"
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="full-width">
              <p>{{ 'attendance.configuration-page.name' | translate }}</p>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="row">
            <div class="col-md-3">
              <p class="mt-4">
                <strong>{{
                  'attendance.configuration-page.meta' | translate
                }}</strong>
              </p>
              <p>
                {{ 'attendance.configuration-page.info-one' | translate }}
              </p>
            </div>

            <div class="col-md-9 mb-3">
              <form [formGroup]="configurationInformationFormGroup">
                <div class="row m-2">
                  <mat-form-field appearance="fill" style="width: 100%">
                    <mat-label>{{
                      'attendance.configuration-page.earliest-clockin'
                        | translate
                    }}</mat-label>
                    <input
                      matInput
                      formControlName="earliest_clockIn_time"
                      [mtxDatetimepicker]="datetimePickerA"
                      (click)="datetimePickerA.open()"
                      readonly
                      required
                    />
                    <mtx-datetimepicker-toggle
                      [for]="datetimePickerA"
                      matSuffix
                    ></mtx-datetimepicker-toggle>
                    <mtx-datetimepicker
                      #datetimePickerA
                      type="time"
                      startView="clock"
                      color="primary"
                      mode="portrait"
                      [twelvehour]="true"
                      [touchUi]="false"
                    >
                    </mtx-datetimepicker>
                    <mat-error>
                      {{
                        'attendance.configuration-page.error-messages.earliest-clockin'
                          | translate
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="row m-2">
                  <mat-form-field matLine style="width: 100%" appearance="fill">
                    <mat-label matLine>{{
                      'attendance.configuration-page.clockin-number' | translate
                    }}</mat-label>
                    <input
                      data-testid="setup_general_input_sys_info_short_name"
                      matInput
                      type="text"
                      (blur)="validateClockInCount()"
                      formControlName="max_number_of_clockins"
                      required
                    />
                    <mat-error
                      *ngIf="
                        configurationInformationFormGroup
                          .get('max_number_of_clockins')
                          .hasError('exceed')
                      "
                    >
                      ClockIn count should not be exceed 3
                    </mat-error>
                    <mat-error
                      *ngIf="
                        configurationInformationFormGroup
                          .get('max_number_of_clockins')
                          .hasError('lessThan')
                      "
                    >
                      ClockIn count should be less than 0
                    </mat-error>
                    <mat-error
                      *ngIf="
                        configurationInformationFormGroup
                          .get('max_number_of_clockins')
                          .hasError('required')
                      "
                    >
                      {{
                        'attendance.configuration-page.error-messages.clockin-number'
                          | translate
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="save-btn" style="margin-right: 10px">
                  <button
                    id="setup_general_btn_sys_info_save_info"
                    data-testid="setup_general_btn_sys_info_save_info"
                    (click)="onConfigurationInfoSubmit()"
                    [disabled]="
                      configurationInformationFormGroup.pristine ||
                      configurationInformationFormGroup.invalid
                    "
                    mat-raised-button
                    color="primary"
                  >
                    {{ 'setup.general.root.save' | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
